import { createContext } from "react";

export interface ModalContextValue {
  // The level the closest Modal above renders at, or undefined when that Modal set none and
  // antd's own default of 1000 applies.
  zIndex?: number;
}

// null outside every Modal, an object inside one, so a Modal can tell "no Modal above me" from
// "a Modal above me that set no zIndex". Modal both reads it and provides it, so a Modal that
// opens from inside another one paints above it instead of falling back to antd's default.
const ModalContext = createContext<ModalContextValue | null>(null);

ModalContext.displayName = "ModalContext";

export default ModalContext;
